import { render, staticRenderFns } from "./WorkExperience.vue?vue&type=template&id=5afd221a&scoped=true"
import script from "./WorkExperience.vue?vue&type=script&lang=js"
export * from "./WorkExperience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd221a",
  null
  
)

export default component.exports